import React from 'react'
import {render} from 'react-dom'
import App from './components/App';

render(<App 
   enableToggle={window.ep19MapConfig.enableToggle} 
   branch={window.ep19MapConfig.branch}
   path={window.ep19MapConfig.path}
   mapPath={window.ep19MapConfig.mapPath}
   logoPath={window.ep19MapConfig.logoPath}
   highlight={window.ep19MapConfig.highlight}
   />, 
   document.querySelector('#ep19InteractiveMap'))


// WEBPACK FOOTER //
// ./src/index.js